"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderServices = orderServices;
Object.defineProperty(exports, "InvalidServiceError", {
  enumerable: true,
  get: function get() {
    return _ServiceManager.InvalidServiceError;
  }
});
exports.ServiceNotFoundError = exports.ServiceAlreadyRegisteredError = exports.ExtractedServiceError = exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _values = _interopRequireDefault(require("lodash/values"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _ServiceManager = _interopRequireWildcard(require("./ServiceManager"));

var _toposort = _interopRequireDefault(require("toposort"));

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ServiceAlreadyRegisteredError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(ServiceAlreadyRegisteredError, _Error);

  var _super = _createSuper(ServiceAlreadyRegisteredError);

  function ServiceAlreadyRegisteredError(name) {
    (0, _classCallCheck2["default"])(this, ServiceAlreadyRegisteredError);
    // prettier-ignore
    return _super.call(this, 'Service with name \'' + name + '\' is already registered with this container.');
  }

  return ServiceAlreadyRegisteredError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

exports.ServiceAlreadyRegisteredError = ServiceAlreadyRegisteredError;

var ServiceNotFoundError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2["default"])(ServiceNotFoundError, _Error2);

  var _super2 = _createSuper(ServiceNotFoundError);

  function ServiceNotFoundError(name) {
    (0, _classCallCheck2["default"])(this, ServiceNotFoundError);
    // prettier-ignore
    return _super2.call(this, 'Service with name \'' + name + '\' cannot be found in this container.');
  }

  return ServiceNotFoundError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

exports.ServiceNotFoundError = ServiceNotFoundError;

var ExtractedServiceError = /*#__PURE__*/function (_Error3) {
  (0, _inherits2["default"])(ExtractedServiceError, _Error3);

  var _super3 = _createSuper(ExtractedServiceError);

  function ExtractedServiceError(name) {
    (0, _classCallCheck2["default"])(this, ExtractedServiceError);
    // prettier-ignore
    return _super3.call(this, 'Service with name \'' + name + '\' has been extracted from the core dai.js library into a discrete plugin. Please refer to the documentation here to install and add it to your configuration: \n\n https://github.com/makerdao/dai.js/wiki/Basic-Usage-(Plugins) \n\n');
  }

  return ExtractedServiceError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error)); // exported just for testing


exports.ExtractedServiceError = ExtractedServiceError;

function orderServices(services) {
  var edges = [];
  var servicesWithoutDeps = [];

  var _iterator = _createForOfIteratorHelper(services),
      _step;

  try {
    var _loop = function _loop() {
      var service = _step.value;
      var name = service.manager().name();
      var depNames = service.manager().dependencies();

      if (depNames.length === 0) {
        servicesWithoutDeps.push(name);
      } else {
        depNames.forEach(function (dn) {
          return edges.push([dn, name]);
        });
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return (0, _uniq["default"])((0, _toposort["default"])(edges).concat(servicesWithoutDeps));
}

var Container = /*#__PURE__*/function () {
  function Container() {
    (0, _classCallCheck2["default"])(this, Container);
    this._services = {};
    this.isAuthenticated = false;
  }

  (0, _createClass2["default"])(Container, [{
    key: "register",
    value: function register(service) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!_ServiceManager["default"].isValidService(service)) {
        throw new _ServiceManager.InvalidServiceError('Service must be an object with manager() method returning a valid ServiceManager');
      }

      name = name || service.manager().name();
      var s = this.service(name, false);

      if (s !== undefined && s !== service) {
        throw new ServiceAlreadyRegisteredError(name);
      }

      this._services[name] = service;
      return this;
    }
  }, {
    key: "service",
    value: function service(name) {
      var throwIfMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var extractedServices = ['exchange'];

      if (!name) {
        throw new Error('Provide a service name.');
      }

      if (!this._services[name] && throwIfMissing && extractedServices.includes(name)) {
        throw new ExtractedServiceError(name);
      }

      if (!this._services[name] && throwIfMissing) {
        throw new ServiceNotFoundError(name);
      }

      return this._services[name];
    }
  }, {
    key: "getRegisteredServiceNames",
    value: function getRegisteredServiceNames() {
      return Object.keys(this._services);
    }
  }, {
    key: "injectDependencies",
    value: function injectDependencies() {
      var services = (0, _values["default"])(this._services);

      var _iterator2 = _createForOfIteratorHelper(services),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var service = _step2.value;
          var manager = service.manager();

          var _iterator3 = _createForOfIteratorHelper(manager.dependencies()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var name = _step3.value;
              var dep = this._services[name];
              if (!dep) throw new ServiceNotFoundError(name);
              manager.inject(name, this._services[name]);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "initialize",
    value: function initialize() {
      return this._waitForServices(function (s) {
        return s.manager().initialize();
      });
    }
  }, {
    key: "connect",
    value: function connect() {
      return this._waitForServices(function (s) {
        return s.manager().connect();
      });
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      var _this = this;

      return this._waitForServices(function (s) {
        return s.manager().authenticate();
      }).then(function () {
        _this.isAuthenticated = true;
      });
    }
  }, {
    key: "_waitForServices",
    value: function () {
      var _waitForServices2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(callback) {
        var _iterator4, _step4, name, service;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._orderedServiceNames) {
                  this._orderedServiceNames = orderServices((0, _values["default"])(this._services));
                }

                _iterator4 = _createForOfIteratorHelper(this._orderedServiceNames);
                _context.prev = 2;

                _iterator4.s();

              case 4:
                if ((_step4 = _iterator4.n()).done) {
                  _context.next = 13;
                  break;
                }

                name = _step4.value;
                service = this._services[name];

                if (service) {
                  _context.next = 9;
                  break;
                }

                throw new Error("No service for ".concat(name));

              case 9:
                _context.next = 11;
                return callback(this._services[name]);

              case 11:
                _context.next = 4;
                break;

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);

                _iterator4.e(_context.t0);

              case 18:
                _context.prev = 18;

                _iterator4.f();

                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 15, 18, 21]]);
      }));

      function _waitForServices(_x) {
        return _waitForServices2.apply(this, arguments);
      }

      return _waitForServices;
    }()
  }]);
  return Container;
}();

exports["default"] = Container;